import { Button, CloseButton, Col, Modal, Row } from "react-bootstrap"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleExclamation } from '@fortawesome/free-solid-svg-icons';
import ErrorIcon from '@mui/icons-material/ErrorOutlined';
import CheckIcon from '@mui/icons-material/CheckCircle';
import Stack from 'react-bootstrap/Stack';
import { STATUSES, DEFAULT_STATE_VALUE, WindowState } from "Utils/constants";
import { PageInfo } from "Components/PageInformation/PageInformation";
import { useRef, useEffect } from "react";
import { ga_log_popup } from "Utils/GA4/GTM";



const Popup = ({
  showPopup,
  handlePopup,
  handleClose,
  popupMsg,
  resetStateValue,
  variant
}) => {

    useEffect(()=>{
        ga_log_popup(variant);
    },[showPopup])

  const modalBody = (variant) => {
    
    switch (variant) {
      case "error":
        
        return (
          <>
            {
              Array.isArray(popupMsg.msg) == true
                ?
                popupMsg["msg"].map((msg) => {
                  return (
                    <PageInfo
                      type="error"
                      message={
                        popupMsg.showContactHelp == false
                          ? msg
                          : <>
                            {msg}
                            &nbsp;Please contact the PSOPPC Help Desk at&nbsp;
                            <a href="mailto:support@psoppc.org">support@psoppc.org</a>&nbsp;
                            to report the issue.
                          </>
                      }
                      classes="mt-2"
                    >
                    </PageInfo>
                  )
                })
                :
                <PageInfo
                  type="error"
                  message={
                    popupMsg.showContactHelp == false
                      ? popupMsg.msg
                      : <>
                        {popupMsg.msg}
                        &nbsp;Please contact the PSOPPC Help Desk at&nbsp;
                        <a href="mailto:support@psoppc.org">support@psoppc.org</a>&nbsp;
                        to report the issue.
                      </>
                  }
                >
                </PageInfo>
            }

            {/*<Stack direction="horizontal" className="popup-message error-message-body">
            <div id="error-icon">
              <ErrorIcon fontSize="small"></ErrorIcon>
            </div>
            <div className="message">
              {popupMsg.msg}
              {popupMsg.showContactHelp == false 
                ? null
                : <>
                    &nbsp;Please contact the PSOPPC Help Desk at&nbsp;
                    <a href="mailto:support@psoppc.org">support@psoppc.org</a>&nbsp;
                    to report the issue.
                  </>
              }
              
            </div>
            </Stack>*/}
          </>
        );
      case "success":

        return (
          <PageInfo
            type="success"
            message={
              popupMsg.msg
            }
          ></PageInfo>
          /*<Stack direction="horizontal" className="popup-message success-message-body">
            <div id="success-icon">
              <CheckIcon fontSize="small"></CheckIcon>
            </div>
            <div className="message">
              {popupMsg.msg}
            </div>
          </Stack>*/
        );
      case "warning":
        
        return (
          <PageInfo
            type="warning"
            message={
              popupMsg.msg
            }
          ></PageInfo>
        );
      case "batch_error":
        return (
          <PageInfo
            type="batch_error"
            message={
              popupMsg.msg
            }
          ></PageInfo>
        );
      default:
        return (
          <PageInfo
            type="info"
            message={
              popupMsg.msg
            }
          ></PageInfo>
          /*<Stack direction="horizontal" className="popup-message default-message-body">
              <div className="message">
                  {popupMsg.msg}
              </div>
          </Stack>*/
        );
    }
  }

  return (
    <>
      <Modal className="modal" size="lg" backdrop="static" keyboard={false} show={showPopup} onHide={handleClose}>
        <Modal.Header>
          <Modal.Title >{popupMsg.title}</Modal.Title>
          <CloseButton className="align-self-start" onClick={handleClose}></CloseButton>
        </Modal.Header>
        <Modal.Body>
          {modalBody(variant)}
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={handleClose} variant="popup-confirm" autoFocus>
            OK
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  )
}

export default Popup;